import React from "react";
import { getPublisherAvatarUrl } from "../../utils";
import {
  formatPostDate,
  getPlainExcerpt,
  getPostTypeLabel,
} from "./educationUtils";
import {
  EducationAuthorLink,
  EducationCardAuthorRow,
  EducationCardExcerpt,
  EducationCardOverlayLink,
  EducationCardRoot,
  EducationCardTitle,
  EducationCategoryBadge,
  EducationCategoryBadges,
  EducationMeta,
  EducationMetaDate,
  EducationTag,
  EducationTags,
  EducationTypeBadge,
  FeaturedContributorBadge,
} from "./Education.styles";

const typeIcon = (typeLabel) =>
  typeLabel === "Video" ? "play_circle" : "menu_book";

const EducationLessonCard = ({ post }) => {
  const typeLabel = getPostTypeLabel(post);
  const author = post.author || {};
  const isFeaturedContributor = Boolean(author.isFeaturedContributor);
  const topics = post.educationTopics || [];

  return (
    <EducationCardRoot>
      <EducationCardAuthorRow>
        <EducationAuthorLink
          to={`/analyst/${author.slug}`}
          onClick={(event) => event.stopPropagation()}
        >
          <img src={getPublisherAvatarUrl(author)} alt="" loading="lazy" />
          <div>
            <strong>{author.name}</strong>
            {author.title && <span>{author.title}</span>}
            {isFeaturedContributor && (
              <FeaturedContributorBadge>
                Featured Contributor
              </FeaturedContributorBadge>
            )}
          </div>
        </EducationAuthorLink>
        <EducationTypeBadge>
          <span className="material-icons" aria-hidden="true">
            {typeIcon(typeLabel)}
          </span>
          {typeLabel}
        </EducationTypeBadge>
      </EducationCardAuthorRow>

      {topics.length > 0 && (
        <EducationCategoryBadges>
          {topics.map((topic) => (
            <EducationCategoryBadge key={topic.id || topic.name}>
              {topic.name}
            </EducationCategoryBadge>
          ))}
        </EducationCategoryBadges>
      )}

      <EducationCardTitle>{post.title}</EducationCardTitle>
      <EducationCardExcerpt>
        {getPlainExcerpt(post.excerpt)}
      </EducationCardExcerpt>

      {!!post.tags?.length && (
        <EducationTags>
          {post.tags.slice(0, 4).map((tag) => (
            <EducationTag key={tag.id || tag.name}>#{tag.name}</EducationTag>
          ))}
        </EducationTags>
      )}

      <EducationMeta>
        <EducationMetaDate>
          <span className="material-icons" aria-hidden="true">
            event
          </span>
          {formatPostDate(post.publishedAt)}
        </EducationMetaDate>
      </EducationMeta>

      <EducationCardOverlayLink to={post.url}>
        <span>Read {post.title}</span>
      </EducationCardOverlayLink>
    </EducationCardRoot>
  );
};

export default EducationLessonCard;
